<login-background>
    <div class="reset-sent">
        <header mat-dialog-title>
            <h1>Your password has been reset.</h1>
        </header>
        You may now exit this browser and proceed to login to the ClareHome app on your mobile device.
    </div>
</login-background>
